
<main-navigation></main-navigation>

<section id="banner" class="d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 text-center text-md-left">
        <h1 class="text-center-md">Portfolio</h1>
        <h2>Take a breath, switch on health, right now.</h2>
        <a href="#" class="btn-get-started scrollto">Get Started</a>
      </div>
    </div>
  </div>
</section>

<main id="main">
  <section id="module" class="module">
    <div class="container">

      <!-- Module Section Introduction -->
      <div class="section-title text-left text-md-center">
        <h2>Series One</h2>
        <p>Introduction</p>
      </div>
      <div class="row module-container justify-content-center">
        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/sand.png" class="img-fluid" alt="">
            <div class="module-info brown">
              <h4>How to use this programme</h4>
              <p>An overview of what's included in the Take a Breath portfolio and how to use it.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-web">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/water.png" class="img-fluid" alt="">
            <div class="module-info dark-green">
              <h4>You Brain and Stress</h4>
              <p>Learn about what's common between all people experiencing stress and anxiety and what needs to
                change.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/gears.png" class="img-fluid" alt="">
            <div class="module-info dark-blue">
              <h4>The Breath Response</h4>
              <p>Understand the direct link between breathing and physical & mental health.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Module Section Introduction -->

      <!-- Module Mechanics of Stress -->
      <div class="section-title text-left text-md-center">
        <h2>Series Two</h2>
        <p>The Mechanic of Stress</p>
      </div>
      <div class="row module-container justify-content-center">
        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/bulb.png" class="img-fluid" alt="">
            <div class="module-info brown">
              <h4>The Switch in Your Brain</h4>
              <p>Understand the precise, physiological change that occurs in your brain when your stress response is
                triggered.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-web">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/water.png" class="img-fluid" alt="">
            <div class="module-info dark-green">
              <h4>The Signs</h4>
              <p>Recognise the physical and mental signs of stress and anxiety, what causes them and how to stop them.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/water2.png" class="img-fluid" alt="">
            <div class="module-info dark-blue">
              <h4>The Challenge</h4>
              <p>Learn the physiological reasons it can be hard to deal with stress and what to do about it.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Mechanics of Stress -->

      <!-- Module Think differently about stress -->
      <div class="section-title text-left text-md-center">
        <h2>Series Three</h2>
        <p>Think differently about Stress</p>
      </div>
      <div class="row module-container justify-content-center">
        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/water3.png" class="img-fluid" alt="">
            <div class="module-info brown">
              <h4>Stress is Physical</h4>
              <p>Understand the physical vs. emotional aspects of stress and the impact this has on how to manage it.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-web">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/sand2.png" class="img-fluid" alt="">
            <div class="module-info dark-green">
              <h4>Stress is not Depressed</h4>
              <p>Learn what your stress indicators are and recognise them as an excellent, physiological mechanism.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/grass.png" class="img-fluid" alt="">
            <div class="module-info dark-blue">
              <h4>Neutral Traits</h4>
              <p>Learn how the brain automates patterns and behaviours and know this impacts stress and anxiety.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Think differently about stress -->

      <!-- Module Switch on Health -->
      <div class="section-title text-left text-md-center">
        <h2>Series Four</h2>
        <p>Switch on Health</p>
      </div>
      <div class="row module-container justify-content-center">
        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/water4.png" class="img-fluid" alt="">
            <div class="module-info brown">
              <h4>Take a Breath</h4>
              <p>Train to breath correctly and how to keep breathing correctly.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-web">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/land.png" class="img-fluid" alt="">
            <div class="module-info dark-green">
              <h4>Problem Solving</h4>
              <p>Understand the impact constructive and negative thinking has on the stress response.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 module-item filter-app">
          <div class="module-wrap">
            <img src="../assets/images/catalogs/water5.png" class="img-fluid" alt="">
            <div class="module-info dark-blue">
              <h4>Default Mode</h4>
              <p>Decide how to manage your screen time, and what your brain does differently when you disconnect.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Switch on Health -->

    </div>
  </section>
</main>

<footer-main></footer-main>

